// format time in seconds to days hrs mins secs
export function secondsToString(totalSeconds, copy) {
  if (!copy) {
    copy = {
      days: "days",
      hours: "hr",
      minutes: "m",
      seconds: "s"
    };
  }

  let days = Math.floor(totalSeconds / 86400);
  totalSeconds %= 86400;
  let hrs = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;
  let mins = Math.floor(totalSeconds / 60);
  let secs = totalSeconds % 60;

  return (
    (days > -1 ? `${days}${copy.days} ` : "") +
    (hrs > -1 ? `${hrs}${copy.hours} ` : "") +
    (mins > -1 ? `${mins}${copy.minutes} ` : "") +
    (secs > -1 ? `${secs}${copy.seconds} ` : `0${copy.seconds}`)
  );
}

// format time in seconds to hrs
export function secondsToHoursString(totalSeconds, copy) {
  return `${Math.floor(totalSeconds / 3600)}${copy || "hrs"}`;
}
